import * as React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../../app/context'
import { TidewaysEvent } from '../../domain/Event'
import Error from '../../errors/details'
import { ApplicationState } from '../../redux/ApplicationState'
import Availability from './availability_down'
import Cron from './cron'
import Maintenance from './maintenance'
import PerformanceComparisonWithTransactions from './performanceComparisonWithTransactions'
import { ActionExecution } from '../../domain/ActionExecution'

interface Props {
    event: TidewaysEvent
    relatedAlertActionExecutions?: ActionExecution[]
    router: any
    tidewaysContext: TidewaysContext
}

class EventDetailsComponent extends React.Component<Props> {
    public render() {
        const { relatedAlertActionExecutions } = this.props
        if (this.props.event.type === 'error') {
            // the following should be fixed, but for that the Error component needs to be refactored.
            // so for now, i suppress the TS error and cry a bit.
            // @ts-ignore
            return <Error parameters={{ error: this.props.event.errorId }} />
        } else if (this.props.event.type === 'response' || this.props.event.type === 'errorrate') {
            // the following should be fixed, but for that the Error component needs to be refactored.
            // so for now, i suppress the TS error and cry a bit.
            // @ts-ignore
            return <Error parameters={{ error: this.props.event.dataCache.incidentId }} />
        }

        return (
            <>
                {(() => {
                    switch (this.props.event.type) {
                        case 'maintenance':
                            return <Maintenance data={this.props.event} />
                        case 'cron':
                            return <Cron data={this.props.event} />
                        case 'release':
                            return (
                                <PerformanceComparisonWithTransactions
                                    title={'Release'}
                                    event={this.props.event}
                                    router={this.props.router}
                                    showDetails={true}
                                    tidewaysContext={this.props.tidewaysContext}
                                    relatedAlertActionExecutions={relatedAlertActionExecutions}
                                />
                            )
                        case 'marker':
                            return (
                                <PerformanceComparisonWithTransactions
                                    title={'Marker'}
                                    event={this.props.event}
                                    router={this.props.router}
                                    showDetails={true}
                                    tidewaysContext={this.props.tidewaysContext}
                                />
                            )
                        case 'down':
                            return <Availability data={this.props.event} />
                        default:
                            return null
                    }
                })()}
            </>
        )
    }
}

export const EventDetails = connect((globalState: ApplicationState) => {
    return {
        router: globalState.tidewaysContext.router,
        tidewaysContext: globalState.tidewaysContext,
    }
})(EventDetailsComponent)
